module.exports = __webpack_public_path__ + "img/seo-checker.fae6815c.png";